import styled from 'styled-components';
import COLORS from '../../utils/Colors';

export const SelectedService = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    background: ${COLORS.freshaGray100};
    border: 1px solid ${COLORS.freshaGray200};
    border-radius: 8px;
    transition: all 0.2s ease;

    &:hover {
        background: ${COLORS.freshaGray200};
        border-color: ${COLORS.freshaGray400};
    }
`;

export const SelectedServiceName = styled.span`
    font-size: 0.875rem;
    font-weight: 500;
    color: ${COLORS.freshaGray900};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 150px;
`;

export const CloseBtn = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    padding: 0;
    border: none;
    background: transparent;
    border-radius: 50%;
    cursor: pointer;
    color: ${COLORS.freshaGray500};
    transition: all 0.15s ease;

    &:hover {
        background: ${COLORS.freshaGray400};
        color: ${COLORS.freshaGray900};
    }

    & svg {
        width: 14px;
        height: 14px;
    }
`;
